module.exports = "/call-frontend/img/add.0b1ebe77.png";